import firebase from 'firebase'
import {
    mapGetters,
    mapMutations,
    mapActions,
  } from 'vuex'
export default {
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters([
      'trips', 'userProfile'
    ])
  },
  methods: {
    getTrips () {
      this.$store.dispatch('getTrips')
    },
    hasJoined (trip) {
      let hasJoined = false
      if (this.userProfile.trips) {
        this.userProfile.trips.forEach(userTrip => {
          if (userTrip === trip.id || hasJoined) {
            hasJoined = true
          }
        })
      }
      return hasJoined
    },

    joinTrip (trip) {
      const join = {
        tripId: trip.id,
        userId: firebase.auth().currentUser.uid
      }
      this.$store.dispatch('joinTrip', join)
      this.userProfile.trips.push(trip.id)
      this.hasJoined(trip)
    },
    retireTrip (trip) {
      const join = {
        tripId: trip.id,
        userId: firebase.auth().currentUser.uid
      }
      this.$store.dispatch('retireTrip', join)
      this.userProfile.trips.splice(this.userProfile.trips.indexOf(trip.id), 1)
      this.hasJoined(trip)
    }
  },
  mounted () {
    this.getTrips()
    console.log(this.trips)
  },

  filters: {
    formatDate: function (value) {
      if (!value) return ''
      const date = new Date(value)
      const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }
      return date.toLocaleDateString('fr-FR', options)
    },
    toFirstUpperCase: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    }
  }

}



// WEBPACK FOOTER //
// ./src/views/Ovr/join/join.js